import React from 'react';
import { Grid, Typography } from '@mui/material';
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import StorageIcon from "@mui/icons-material/Storage";
import StatCard from './StatCard';
import strings from '../../strings';

const HomeStats = ({ stats, loadingDocuments, loadingRecords, onFetchTotalDocuments, onFetchTotalRecords }) => {
  return (
    <>
      <Grid size={{ xs: 12, md: 6 }}>
        <StatCard
          title={strings.home.stats.totalLibraryDocuments}
          value={stats.totalDocuments}
          icon={<LibraryBooksIcon sx={{ color: 'primary.main', fontSize: 30 }} />}
          color="primary.main"
          onGetTotal={onFetchTotalDocuments}
          loading={loadingDocuments}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <StatCard
          title={strings.home.stats.totalDatabaseRecords}
          value={stats.totalRecords}
          icon={<StorageIcon sx={{ color: 'primary.main', fontSize: 30 }} />}
          color="primary.main"
          onGetTotal={onFetchTotalRecords}
          loading={loadingRecords}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Typography 
          variant="caption" 
          color="text.secondary" 
          sx={{ 
            display: 'block', 
            mt: 1,
            fontStyle: 'italic',
            fontSize: '0.75rem',
            lineHeight: 1.2,
            textAlign: 'center'
          }}
        >
          {strings.home.stats.loadingNote}
        </Typography>
      </Grid>
    </>
  );
};

export default HomeStats; 